import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  max-width: 1360px !important;
  min-width: 633px !important;
`

export const MainContainer = styled.div`
  gap: ${props => props.theme.spacing.sp32};
  display: grid;
  grid-template-columns: 60% calc(40% - ${props => props.theme.spacing.sp32});

  @media screen and (max-width: 1163px) {
    grid-template-columns: 100%;
  }
`
